import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Dropdown_, FormBox, FormBoxTitle, Main_Loader, Main_Plain } from 'monica-alexandria';
import { useTranslation } from 'react-i18next';
import { get_agency_preoffer_reviewers } from '../../../../services/api/Offers';

const NewOfferReviewer = styled(FormBox)`
    display: grid;
    gap: var(--normalPads);
    color: ${p => p.theme.color};
`;

const NewOfferReviewerError = styled.p`
    color: var(--error);
`;

export default function New_Offer_Reviewer(props) {
    const { t } = useTranslation();
    const [reviewers, setReviewers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [retry, setRetry] = useState(0);
    const [currentReviewerUserId, setCurrentReviewerUserId] = useState(props.currentUserId || '');

    useEffect(() => {
        let mounted = true;
        setLoading(true);
        setError('');
        props.onOptions([]);

        get_agency_preoffer_reviewers(props.offerType).then((response) => {
            if (!mounted) {
                return;
            }

            const members = response.data.data.reviewers;
            const defaultReviewer = response.data.data.defaultReviewerUserId;
            if ((!props.value || props.selectionMode === 'default') && defaultReviewer) {
                props.onChange(defaultReviewer, 'default');
            } else if (props.selectionMode === 'default' && props.value && !defaultReviewer) {
                props.onChange('', 'default');
            }
            setReviewers(members);
            const currentId = response.data.data.creatorMember?.userId || props.currentUserId || '';
            setCurrentReviewerUserId(currentId);
            props.onOptions(members, currentId);
        }).catch(() => {
            if (mounted) {
                setError('Could not load reviewers. Your offer details are saved in this form.');
            }
        }).finally(() => {
            if (mounted) {
                setLoading(false);
            }
        });

        return () => {
            mounted = false;
        };
    }, [props.offerType, retry]);

    return (
        <NewOfferReviewer>
            <FormBoxTitle>
                <h4>{t('Reviewer')}</h4>
            </FormBoxTitle>
            {loading ? (
                <Main_Loader></Main_Loader>
            ) : null}
            {error ? (
                <NewOfferReviewerError>{t(error)}</NewOfferReviewerError>
            ) : null}
            {!loading && !error && !reviewers.length ? (
                <p>{t('No active team members are available. Check membership, then retry.')}</p>
            ) : null}
            {!loading && !error && reviewers.length > 0 ? (
                <Dropdown_ label={t('Reviewer')}>
                    <select
                        aria-label={t('Reviewer')}
                        required
                        value={props.value}
                        onChange={(event) => props.onChange(event.target.value)}
                    >
                        <option value="">{t('Select a reviewer')}</option>
                        {reviewers.map((reviewer) => (
                            <option key={reviewer.userId} value={reviewer.userId}>
                                {`${reviewer.firstname} ${reviewer.lastname}`.trim()}
                            </option>
                        ))}
                    </select>
                </Dropdown_>
            ) : null}
            {!loading && !error && reviewers.some((reviewer) => reviewer.userId === currentReviewerUserId) ? (
                <Main_Plain text={t('Assign to me')} onClick={() => props.onChange(currentReviewerUserId)}></Main_Plain>
            ) : null}
            {!loading && (error || !reviewers.length) ? (
                <Main_Plain noPadding text={t('Retry')} onClick={() => setRetry(retry + 1)}></Main_Plain>
            ) : null}
        </NewOfferReviewer>
    );
}
